<template>
  <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
  <div class="container mt-4">
    <h2 class="mb-4 text-primary">Student Payments Summary</h2>

    <!-- Filters -->
    <!-- Filters -->
<div class="mb-4 row gx-3 gy-2 align-items-center">
  <div class="col-12 col-md-6">
    <select class="form-select w-100" v-model="filter">
      <option value="all">All Payments</option>
      <option value="last">Last Payment</option>
      <option value="today">Today's Payments</option>
      <option value="month">This Month's Payments</option>
    </select>
  </div>

  <div class="col-12 col-md-6">
    <select v-model="selectedSubject" class="form-select w-100" id="subject">
      <option value="">-- All Subject --</option>
      <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
        {{ subject.name }}
      </option>
    </select>
  </div>
</div>


    <!-- Total Amount -->
    <div class="alert alert-info" role="alert" v-if="totalAmount">
      <strong>Total Amount:</strong> {{ totalAmount.toLocaleString() }}
    </div>

    <!-- Loading Spinner -->
<div v-if="loading" class="d-flex justify-content-center align-items-center my-5">
  <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div v-else>
    <!-- Payment Table -->
    <div v-if="students.length">
      <div class="table-responsive">
        <table class="table table-bordered table-hover align-middle text-nowrap">
          <thead class="table-dark">
            <tr>
              <th>Student Name</th>
              <!-- <th>Item ID</th> -->
              <th>Subject</th>
              <th>Amount</th>
              <th>Payment Date</th>
              <th>Paid With</th>
              <th>Teacher</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="student in students" :key="student.id">
              <template v-for="(payment, index) in student.payments" :key="payment.id">
                <tr>
                  <td v-if="index === 0" :rowspan="student.payments.length">
                    {{ student.first_name || '—' }} {{ student.last_name || '' }}
                  </td>
                  <!-- <td>{{ payment.student_items?.id || '—' }}</td> -->
                  <td>{{ payment.student_items?.subject?.name || '—' }}</td>
                  <td>{{ payment.amount }}</td>
                  <td>{{ payment.payment_date }}</td>
                  <td>{{ payment.payment_option || '—' }}</td>
                  <td>{{ payment.student_items?.teacher?.user?.first_name || '—' }}</td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center mt-3">
        <button
          class="btn btn-outline-primary"
          :disabled="currentPage === 1"
          @click="goToPage(currentPage - 1)"
        >
          Prev
        </button>
        <span class="fw-bold">Page {{ currentPage }} of {{ totalPages }}</span>
        <button
          class="btn btn-outline-primary"
          :disabled="currentPage === totalPages"
          @click="goToPage(currentPage + 1)"
        >
          Next
        </button>
      </div>
    </div>

    <!-- Empty State -->
    <!-- Empty State -->
<div v-else class="text-muted mt-4">
  <p>No payments found for the selected filter and subject.</p>
</div>

  </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      students: [],
      filter: 'all',
      loading: false,
      subjects: [],
      selectedSubject: '',
      currentPage: 1,
      perPage: 1,
      totalPages: 1,
      totalAmount: 0,
    };
  },
  computed: {
    uniqueSubjects() {
      const subjects = new Set();
      this.students.forEach((student) => {
        student.payments.forEach((payment) => {
          const subjectName = payment.student_items?.subject?.name;
          if (subjectName) {
            subjects.add(subjectName);
          }
        });
      });
      return Array.from(subjects);
    },
  },
  methods: {
    fetchStudents(page = 1) {
  const instituteId = localStorage.getItem('institute_id');
  if (!instituteId) return;

  this.loading = true;

  axios
    .get(`/get-institute-payment?page=${page}&per_page=${this.perPage}&filter=${this.filter}&subject=${this.selectedSubject}`, {
      headers: {
        'Institute-ID': instituteId,
      },
    })
    .then((response) => {
      this.students = response.data.data;
      this.currentPage = response.data.current_page;
      this.totalPages = response.data.last_page;
      this.totalAmount = response.data.total_amount || 0;
      
    })
    .catch((error) => {
      console.error('Error fetching students:', error);
    })
    .finally(() => {
      this.loading = false;
    });
},
fetchSubjects() {
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-subjects-by-institute', {
          params: { institute_id: instituteId }
        })
        .then(response => {
          this.subjects = response.data;
        })
        .catch(error => {
          console.error('Error fetching subjects:', error);
        });
      },

    goToPage(page) {
      this.fetchStudents(page);
    },
  },
  mounted() {
    this.fetchStudents();
    this.fetchSubjects();
  },
  watch: {
    filter() {
      this.fetchStudents();
    },
    selectedSubject() {
      this.fetchStudents();
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  padding: 0 15px;
}

.form-select {
  min-width: 200px;
}

.alert-info {
  font-size: 1.1rem;
  font-weight: 500;
}

@media (max-width: 769px) {

  .container {
  max-width: 300px;
  padding: 0 0px;
}

.form-select {
  min-width: 300px;
}


  table thead {
    font-size: 0.9rem;
  }

  table td, table th {
    white-space: nowrap;
    font-size: 0.85rem;
  }

  .alert-info {
    font-size: 1rem;
  }

  .table-responsive {
    overflow-x: auto;
  }
}

</style>
